const menu = {
  label: '• Metodologia',
  to: '/sol/metodologia',
  rules: ['SOL-001'],
}

export default menu;